import React, { useEffect, useState } from 'react';
import { useTasksContext } from '../../providers/TasksContextProvider';
import { useTaskListenerContext } from './TaskListenerContextProvider';
import { createToggleHandler } from './Avoda';
import PrioFilterBtn from './PrioFilterBtn';
import './PriosBar.css';


const PriosBar = () => {
  const {prios, setPrios}                 = useTasksContext();
  const {tasksChanged}                    = useTaskListenerContext();
  const [renderedPrios, setRenderedPrios] = useState(null);

  const togglePrio = createToggleHandler(setPrios);

  useEffect(()=>{
    if (prios) {
      setRenderedPrios(prios);
    }
  },[prios, tasksChanged]);
  
  const compPriosList = renderedPrios ? Object.entries(renderedPrios)
        .sort(([a], [b]) => b - a) // Sort prio descending
        .map(([prio, status]) => <PrioFilterBtn prio={prio} 
                                                key={prio} 
                                                clickMe={() => togglePrio(prio)} 
                                                isActive={status.isSelected}/>)
        : null; 

  return (
    <div className='priosBar'>
      {compPriosList}
      {/* <PriorityBall priority={4} title='No Priority' /> */}
    </div>
  );
};

export default PriosBar;